class ShirtProduct {
  static basePrice(currency, conversions) {
    const conversionTable = conversions[0];

    return conversionTable.data[currency.toUpperCase()];
  }

  static calculatedPrice(conversions) {
    const currencies = ['usd', 'gbp', 'aud', 'cad', 'eur'];
    let prices = {};

    for (let currency of currencies) {
      let price = ShirtProduct.basePrice(currency, conversions);

      prices[currency] = price;
    }

    return prices;
  }

  static compiledId(reference, size, color) {
    return `${reference}-${size}-${color}`.toLowerCase();
  }

  static description(size, color) {
    return `T-Shirt, ${color}, ${ShirtProduct.prototype.sizeLabels[size]}`;
  }

  static entriesForPriceTable(data, server_root) {
    let result = [];

    for (let size in ShirtProduct.prototype.sizeLabels) {
      data.Colors.forEach(color => {
        result.push({
          id: ShirtProduct.compiledId(data.Reference, size, color),
          price: (
            (data.Discount_Price_Profile && data.Discount_Price_Profile.length > 0) ?
              ShirtProduct.calculatedPrice(data.Discount_Price_Profile[0].data.Conversions)
              :
              ShirtProduct.calculatedPrice(data.Price_Profile[0].data.Conversions)
          ),
          url: `${server_root}/data/products/${data.Reference}.json`,
        });
      });
    }

    return result;
  }
}

ShirtProduct.prototype.sizeLabels = {
  'S': 'Small',
  'M': 'Medium',
  'L': 'Large',
  'XL': 'X-Large'
};

module.exports = ShirtProduct;
